import React from "react";
import "./GameModal.css";

const GameModal = ({ onClose }) => {
  return (
    <div className="game-modal-overlay">
      <div className="game-modal">
        <button className="close-btn" onClick={onClose}>✖</button>
        <h2>Shall we play a game?</h2>
        <iframe
          title="pong"
          src="https://ponggame.io/"
          width="100%"
          height="500"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
};

export default GameModal;
